import React, { useEffect, useState } from 'react';
import { Menu, X, Flag } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Mission',
    href: '#mission'
  }, {
    name: 'Issues',
    href: '#issues'
  }, {
    name: 'Leadership',
    href: '#leadership'
  }, {
    name: 'News',
    href: '#news'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-pac-navy/95 backdrop-blur-md shadow-lg py-3' : 'bg-pac-navy py-5'}`} data-id="element-142">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        <div className="flex justify-between items-center" data-id="element-144">
          {/* Logo */}
          <div className="flex items-center gap-2" data-id="element-145">
            <Flag className="h-8 w-8 text-pac-gold" data-id="element-146" />
            <div className="flex flex-col" data-id="element-147">
              <span className="font-serif font-bold text-xl leading-tight text-white tracking-wide uppercase" data-id="element-148">
                West Valley
              </span>
              <span className="text-[10px] font-sans font-semibold text-pac-gold tracking-[0.2em] uppercase" data-id="element-149">
                Leadership PAC
              </span>
            </div>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-150">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-200 hover:text-white transition-colors uppercase tracking-wider" data-id="element-151">
                {link.name}
              </a>)}
            <a href="#donate" className="bg-pac-red hover:bg-red-800 text-white px-6 py-2.5 rounded font-bold tracking-wider uppercase transition-all shadow-[0_0_15px_rgba(185,28,28,0.5)] hover:shadow-[0_0_25px_rgba(185,28,28,0.8)] transform hover:-translate-y-0.5" data-id="element-152">
              Donate Now
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-153">
            {mobileMenuOpen ? <X className="h-6 w-6" data-id="element-154" /> : <Menu className="h-6 w-6" data-id="element-155" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-156">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-pac-navy border-t border-slate-800 overflow-hidden" data-id="element-157">
            <div className="px-4 py-6 flex flex-col gap-4" data-id="element-158">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-slate-200 hover:text-white uppercase tracking-wider block py-2" data-id="element-159">
                  {link.name}
                </a>)}
              <a href="#donate" onClick={() => setMobileMenuOpen(false)} className="bg-pac-red text-white px-6 py-4 rounded font-bold tracking-wider uppercase text-center mt-4" data-id="element-160">
                Donate Now
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}